import type { RegionalPage } from '../../adapters/regional-http';
import type { GeoPoint, GeoProjection } from '../../consumer/geospatial/projection';
import { coordinates } from '../../consumer/geospatial/projection';
/** Reuse VS09 NASA/NOAA layers; immutable VS07 read fallback never changes live layers. */
export function frozenRegionalGeo(page: RegionalPage | null, search: string): GeoProjection {
  const result: GeoProjection = {
    nasa: { type: 'FeatureCollection', features: [] },
    noaa: { type: 'FeatureCollection', features: [] },
    boundary: { type: 'FeatureCollection', features: [] },
    rejected: 0,
    duplicates: 0,
    scopeValid: true,
  };
  if (page?.sourceMode !== 'HISTORICAL_RESEARCH') return result;
  const q = new URLSearchParams(search),
    filter = q.get('filter') ?? 'all',
    area = q.get('areaRef');
  const stations = new Set<string>();
  for (const a of page.items) {
    if (area && area !== a.profile.regionId) continue;
    for (const e of a.evidence) {
      if (e.mode !== 'HISTORICAL_RESEARCH') continue;
      const point = e.geometry[0];
      if (!point || !coordinates(point[0], point[1])) {
        result.rejected++;
        continue;
      }
      const nasa = e.kind === 'THERMAL_ANOMALY_CANDIDATE';
      if (!nasa && e.kind !== 'HISTORICAL_STATION_CONTEXT') continue;
      const linked = e.detail.association === 'WEATHER_CONTEXT_LINKED';
      if (nasa && ((filter === 'linked' && !linked) || (filter === 'unlinked' && linked))) continue;
      if (!nasa && stations.has(e.sourceId)) {
        result.duplicates++;
        continue;
      }
      if (!nasa) stations.add(e.sourceId);
      const feature: GeoPoint = {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [point[0]!, point[1]!] },
        properties: {
          id: nasa ? e.id : e.sourceId,
          kind: nasa ? 'NASA_HISTORICAL' : 'NOAA_STATION',
          sourceAuthority: e.provider,
          timestamp: e.observedAt,
          rawRef: e.evidenceDigest,
          title: nasa ? 'VS07 历史热异常 · NOT_VERIFIED' : e.sourceId + ' · 历史区域背景',
        },
      };
      (nasa ? result.nasa : result.noaa).features.push(feature);
    }
  }
  return result;
}
